import '../../../components/Modal/Modal.css';

const Modal = (props) => {
  const { title, text, children, modalContentClassname,textClassName } = props;

  return (
    <div id='modal' className={`modal-overlay`}>
      <div
        id='modal-content'
        className={
          `bg-white md:p-8 p-5 rounded-lg shadow-lg max-w-md w-full flex flex-col gap-8 ` +
          modalContentClassname
        }
      >
        <div className='flex flex-col gap-3 items-start'>
          <h2 className='leading-[0.8] text-red-black font-[700] xl:text-[40px] md:text-[35px] sm:text-[30px] text-[25px] '>
            {title}
          </h2>
          {text && (
            <p
              dangerouslySetInnerHTML={{ __html: text }}
              className={
                'font-[400] leading-[30px] text-gray-3 xl:text-[20px] md:text-[18px] sm:text-[18px] xs:text-[16px] ' +
                textClassName
              }
            ></p>
          )}
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
